export const SocketEvent = {
  BOOT_RESULT: "boot_result",
  CREATE_VM_RESULT: "create_vm_result",
  VM_RESULT: "vm_result",
  JOIN_ROOM: "join",
  RECHARGE_RESULT: "recharge_result",
  ERROR_RESPONSE: "error_response",
  VERIFY_PHONE_RESPONSE: "verify_phone_response",
};
